var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"box-border-state"},[_c('div',{staticClass:"boxContainer"},[_c('img',{attrs:{"src":"/img/valueDeploymentState.svg"}}),_c('p',{staticClass:"emptyText"},[_vm._v("Your money is getting deployed in loans.")])])])
}]

export { render, staticRenderFns }